import { produce } from "immer";
import {
  FETCH_ROTA,
  FETCH_ROTA_SUCCESS,
  FETCH_ROTA_FAILURE,
  //
  BULK_PUBLISH,
  BULK_PUBLISH_SUCCESS,
  BULK_PUBLISH_FAILURE,
  //
  FETCH_ROTA_STAT,
  FETCH_ROTA_STAT_SUCCESS,
  FETCH_ROTA_STAT_FAILURE,
  //
  FETCH_SHIFTS,
  FETCH_SHIFTS_SUCCESS,
  FETCH_SHIFTS_FAILURE,
  UPDATE_SHIFTS,
  UPDATE_ROTA,
  UPDATE_STAT,
  //
  TOGGLE_PRINT,
  //
  SET_ALLOC_FILTERS,
  //
  GET_SHIFT_STATS,
  GET_SHIFT_STATS_SUCCESS,
  GET_SHIFT_STATS_FAILURE,
} from "./constants";
import moment from "moment";
import { getDatesInRange } from "../../utils/dates";

let first = moment().startOf("month").format("YYYY-MM-DD");
let last = moment().endOf("month").format("YYYY-MM-DD");

export const initialState = {
  isFetchingRota: false,
  isFetchingStats: false,
  isPublishing: false,
  publishingType: null,
  rota: [],
  stats: [],
  isFetchingShifts: false,
  rotaShifts: [],
  printModal: false,
  allocFilters: {
    month: moment().format("MMMM"),
    from_date: first,
    to_date: last,
  },
  allocList: getDatesInRange(first, last),
  day: new Date(),
  isFetchingShiftStats: false,
  shiftStats: {
    acknowledgedshiftCount: 0,
    unacknowledgedshiftCount: 0,
    total_acknowledged_shift: 0,
  },
};

const RotaReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_ROTA:
        draft.isFetchingRota = true;
        draft.rota = [];
        break;
      case FETCH_ROTA_SUCCESS:
        draft.isFetchingRota = false;
        draft.rota = action.payload;
        break;
      case FETCH_ROTA_FAILURE:
        draft.isFetchingRota = false;
        draft.rota = [];
        break;

      case BULK_PUBLISH:
        draft.isPublishing = true;
        draft.publishingType = action.payload?.type ?? null;
        break;
      case BULK_PUBLISH_SUCCESS:
        draft.isPublishing = false;
        draft.publishingType = null;
        break;
      case BULK_PUBLISH_FAILURE:
        draft.isPublishing = false;
        draft.publishingType = null;
        break;

      case FETCH_ROTA_STAT:
        draft.isFetchingStats = true;
        draft.unpublishedCount = 0;
        break;
      case FETCH_ROTA_STAT_SUCCESS:
        draft.isFetchingStats = false;
        draft.unpublishedCount = action.payload;
        break;
      case FETCH_ROTA_STAT_FAILURE:
        draft.isFetchingStats = false;
        draft.unpublishedCount = 0;
        break;

      case UPDATE_STAT:
        draft.unpublishedCount = action.payload;
        break;

      case FETCH_SHIFTS:
        draft.isFetchingShifts = true;
        draft.rotaShifts = [];
        break;
      case FETCH_SHIFTS_SUCCESS:
        draft.isFetchingShifts = false;
        draft.rotaShifts = action.payload;
        break;
      case FETCH_SHIFTS_FAILURE:
        draft.isFetchingShifts = false;
        draft.rotaShifts = [];
        break;
      case UPDATE_SHIFTS:
        draft.rotaShifts = action.payload;
        break;
      case UPDATE_ROTA:
        draft.rota = action.payload;
        break;

      case TOGGLE_PRINT:
        draft.printModal = action.payload;
        break;

      case SET_ALLOC_FILTERS:
        draft.allocFilters = action.payload;
        break;

      case GET_SHIFT_STATS:
        draft.isFetchingShiftStats = true;
        break;
      case GET_SHIFT_STATS_SUCCESS:
        draft.isFetchingShiftStats = false;
        draft.shiftStats = action.payload;
        break;
      case GET_SHIFT_STATS_FAILURE:
        draft.isFetchingShiftStats = false;
        break;

      default:
        return state;
    }
  });

export default RotaReducer;
